import React from 'react';
import './PressReleases.css';

const PressReleases = () => {
  const pressReleases = [
    {
      id: 1,
              title: "Inifiy Launches New Mobile App for Enhanced Shopping Experience",
      date: "January 15, 2024",
      excerpt: "We're excited to announce the launch of our new mobile application, designed to provide customers with a seamless shopping experience on-the-go.",
      category: "Product Launch"
    },
    {
      id: 2,
              title: "Inifiy Expands to 50+ Countries Worldwide",
      date: "December 20, 2023",
      excerpt: "Our platform is now available in over 50 countries, bringing our diverse product selection to customers around the globe.",
      category: "Company News"
    },
    {
      id: 3,
              title: "Inifiy Partners with Leading Tech Brands",
      date: "November 10, 2023",
      excerpt: "We're proud to announce new partnerships with top technology brands to offer customers the latest gadgets and electronics.",
      category: "Partnerships"
    },
    {
      id: 4,
              title: "Inifiy Achieves 1 Million Customer Milestone",
      date: "October 25, 2023",
      excerpt: "We've reached a significant milestone with over 1 million satisfied customers worldwide, marking a major achievement in our growth journey.",
      category: "Milestone"
    },
    {
      id: 5,
      title: "New Sustainability Initiative Launched",
      date: "September 15, 2023",
              excerpt: "Inifiy is committed to environmental responsibility with our new sustainability program and eco-friendly packaging options.",
      category: "Sustainability"
    },
    {
      id: 6,
              title: "Inifiy Introduces AI-Powered Product Recommendations",
      date: "August 30, 2023",
      excerpt: "Our new AI technology provides personalized product recommendations to help customers discover items they'll love.",
      category: "Technology"
    }
  ];

  return (
    <div className="press-page">
      {/* Hero Section */}
      <div className="press-hero">
        <div className="press-hero-content">
          <h1>Press Releases</h1>
          <p>Stay updated with the latest news and announcements from Inifiy</p>
        </div>
      </div>

      <div className="press-container">
        <div className="press-content">
          <div className="press-section">
            <h2>Latest News</h2>
            <div className="press-releases">
              {pressReleases.map(release => (
                <div key={release.id} className="press-release">
                  <div className="release-header">
                    <span className="release-category">{release.category}</span>
                    <span className="release-date">{release.date}</span>
                  </div>
                  <h3 className="release-title">{release.title}</h3>
                  <p className="release-excerpt">{release.excerpt}</p>
                  <button className="read-more-btn">Read Full Release</button>
                </div>
              ))}
            </div>
          </div>

          <div className="press-section">
            <h2>Media Kit</h2>
            <div className="media-kit">
              <div className="media-item">
                <div className="media-icon">📷</div>
                <h3>Company Logo</h3>
                <p>High-resolution logos in various formats</p>
                <button className="download-btn">Download</button>
              </div>
              <div className="media-item">
                <div className="media-icon">📄</div>
                <h3>Press Kit</h3>
                <p>Complete company information and statistics</p>
                <button className="download-btn">Download</button>
              </div>
              <div className="media-item">
                <div className="media-icon">📊</div>
                <h3>Fact Sheet</h3>
                <p>Key facts and figures about our company</p>
                <button className="download-btn">Download</button>
              </div>
            </div>
          </div>

          <div className="press-section">
            <h2>Contact Our Press Team</h2>
            <div className="press-contact">
              <div className="contact-info">
                <h3>Media Inquiries</h3>
                <p>For press inquiries, interviews, or media partnerships, please contact our press team:</p>
                <div className="contact-details">
                  <div className="contact-detail">
                    <span className="detail-label">Email:</span>
                    <span className="detail-value">press@inifiy.com</span>
                  </div>
                  <div className="contact-detail">
                    <span className="detail-label">Phone:</span>
                    <span className="detail-value">+1 (555) 123-4567</span>
                  </div>
                  <div className="contact-detail">
                    <span className="detail-label">Address:</span>
                    <span className="detail-value">123 E-commerce Street, Digital City, DC 12345</span>
                  </div>
                </div>
              </div>
              <div className="contact-form">
                <h3>Send us a Message</h3>
                <form>
                  <div className="form-group">
                    <label>Name</label>
                    <input type="text" placeholder="Your name" />
                  </div>
                  <div className="form-group">
                    <label>Email</label>
                    <input type="email" placeholder="Your email" />
                  </div>
                  <div className="form-group">
                    <label>Organization</label>
                    <input type="text" placeholder="Your organization" />
                  </div>
                  <div className="form-group">
                    <label>Message</label>
                    <textarea placeholder="Your message" rows="4"></textarea>
                  </div>
                  <button type="submit" className="submit-btn">Send Message</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PressReleases; 